import { useState, useEffect } from 'react';

interface WorkspaceTransitionProps {
  onComplete: () => void;
}

export function WorkspaceTransition({ onComplete }: WorkspaceTransitionProps) {
  const [phase, setPhase] = useState<'enter' | 'hold' | 'exit'>('enter');

  useEffect(() => {
    const holdTimer = setTimeout(() => setPhase('hold'), 200);
    const exitTimer = setTimeout(() => setPhase('exit'), 350);
    const completeTimer = setTimeout(() => onComplete(), 550);

    return () => {
      clearTimeout(holdTimer);
      clearTimeout(exitTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div
      className={`fixed inset-0 z-50 pointer-events-none transition-opacity duration-200 ${
        phase === 'exit' ? 'opacity-0' : 'opacity-100'
      }`}
      style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16162a 50%, #0f0f1e 100%)',
      }}
    />
  );
}
